// ...other imports
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import baseUrl from "../../api/universalApi";
import VrfDetails from "./VrfDetails";
import { useSelector } from "react-redux";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

const NewCampaign = ({
  creatorData,
  vrfDetails,
  formState,
  setFormState,
  setVrfDetails,
  fetchCampaignsData,
}) => {
  const [loading, setLoading] = useState(false);
  const [importVrf, setImportVrf] = useState(false);
  //const creatorData = useSelector((state) => state.auth?.authData?.user); // Assuming you have a Redux store or context for creator data
  const [formData, setFormData] = useState({
    creatorId: creatorData?._id || "",
    campaignTitle: "",
    platform: "",
    brandName: "",
    pocEmail: "",
    vrfFile: null,
    comments: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const fetchVrfDetails = async (id) => {
    try {
      const res = await axios.get(`${baseUrl}/api/agreement/vrf/${id}`, {
        headers: {
          "Cache-Control": "no-cache",
        },
      });
      // console.log("VRF Details Response:", res.data);
      setFormData((prev) => ({
        ...prev,
        vrfFile: res.data?.vrfDetails || null,
      }));
      // console.log("Form Data after VRF Fetch:", formData);
    } catch (err) {
      console.error("Failed to fetch VRF details", err);
      setError("Failed to fetch VRF details. Please try again later.");
      setFormData((prev) => ({ ...prev, vrfFile: null }));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    setLoading(true);

    e.preventDefault();
    setError("");

    const payload = { ...formData };

    //  console.log("Form Data:", payload);

    try {
      const response = await fetch(`${baseUrl}/api/campaign/createCampaign`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to submit form");
      }

      const data = await response.json();

      //  console.log("Response Data:", data);

      toast.success("Campaign created successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      //clear formdata
      setFormData({
        creatorId: creatorData?._id || "",
        campaignTitle: "",
        platform: "",
        brandName: "",
        pocEmail: "",
        vrfFile: null,
        comments: "",
      });

      setImportVrf(false)



      fetchCampaignsData(creatorData?._id);

      setTimeout(() => {
        // Reset loading state after 2 seconds
        setLoading(false);
      }, 1000);

      // navigate("/creatorpay/campaigns");
    } catch (err) {
      setError(err.message);
      setTimeout(() => {
        // Reset loading state after 2 seconds
        setLoading(false);
      }, 1000);
    }
  };

  return (
    <div className="w-full mx-auto   p-3 rounded" style={{ overflowY: "auto" }}>
      <h2 className="text-2xl font-bold mb-3 text-start">Create Campaign</h2>
      {error && <div className="text-red-500 mb-4 text-center">{error}</div>}
      <form
        onSubmit={handleSubmit}
        className="space-y-3 flex flex-col justify-start items-start  p-3 w-full rounded"
      >
        <div className="grid grid-cols-2 gap-6">
          <div className="w-full">
            <label htmlFor="title" className="block text-sm font-medium mb-1">
              Campaign Title
            </label>
            <input
              id="title"
              name="campaignTitle"
              placeholder="Campaign Title"
              className="w-full border border-gray-300 rounded px-3 py-2 "
              value={formData.campaignTitle}
              onChange={handleChange}
              required
            />
          </div>

          <div className="w-full">
            <label
              htmlFor="platform"
              className="block text-sm font-medium mb-1"
            >
              Platform
            </label>
            <select
              id="platform"
              name="platform"
              className="w-full border border-gray-300 rounded px-3 py-2 bg-white "
              value={formData.platform}
              onChange={handleChange}
              required
            >
              <option value="">Select Platform</option>
              <option value="Instagram">Instagram</option>
              <option value="YouTube">YouTube</option>
              <option value="TikTok">TikTok</option>
            </select>
          </div>

          <div className="w-full">
            <label htmlFor="brand" className="block text-sm font-medium mb-1">
              Brand Name{" "}
              <span className="text-xs text-gray-500">
                (as per actual name for GST verification)
              </span>
            </label>
            <input
              id="brand"
              name="brandName"
              placeholder="Brand Name"
              className="w-full border border-gray-300 rounded px-3 py-2 "
              value={formData.brandName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="w-full">
            <label htmlFor="poc" className="block text-sm font-medium mb-1">
              POC Email/Phone Number
            </label>
            <input
              id="poc"
              name="pocEmail"
              placeholder="POC email/phone number"
              className="w-full border border-gray-300 rounded px-3 py-2 "
              value={formData.pocEmail}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="w-full">
          <label htmlFor="vrfFile" className="block text-sm font-medium mb-1">
            VRF File (VRF)
          </label>

          {
            <VrfDetails
              className="w-full"
              vrfDetails={vrfDetails}
              formState={formState}
              setFormState={setFormState}
              setVrfDetails={setVrfDetails}
            />
          }
          <button
            type="button"
            className={`ml- mt-2 ${
              importVrf
                ? "bg-green-600 hover:bg-green-700"
                : "bg-blue-600 hover:bg-blue-700"
            } text-white px-3 py-1 rounded-full transition`}
            onClick={() => {
              setImportVrf(true);
              fetchVrfDetails(creatorData?._id);
            }}
          >
            {importVrf ? "Imported" : "Import VRF"}
          </button>
        </div>

        <div className="w-full">
          <label htmlFor="comments" className="block text-sm font-medium mb-1">
            Description/Comments
          </label>
          <textarea
            id="comments"
            name="comments"
            placeholder="Description/comments"
            className="w-1/2 border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows="4"
            value={formData.comments}
            onChange={handleChange}
            required
          />
        </div>

        <div className="flex justify-center">
          <button
            type="submit"
            className="bg-blue-600 text-white px-3 py-1 rounded-full hover:bg-blue-700 transition "
          >
            {loading ? (
              <span className="animate-spin inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full"></span>
            ) : null}
            Create Campaign
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewCampaign;
